import React,{useContext}  from 'react';
import { Languages } from '../../Helper/languages';
import {DataContext} from "../../Helper/context";
import PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap-accordion';

import './styles.scss'

Faqs2.propTypes = {
    data : PropTypes.array,
};

function Faqs2(props) {
    const {language} = useContext(DataContext);

    const data = Languages[language].FAQ
    return (
        <section className="tf-faq tf-section">
                <div className="tf-container">
                    <div className="col-md-12 ">
                        <div className="tf-heading mb60 wow fadeInUp">
                            <h2 className="heading">FAQS</h2>
                        </div>
                    </div> 
                   <div className="row justify-content-center">
                        <div className="col-md-8 wow fadeInUp">
                            <div className="tf-flat-accordion2">
                                {
                                    data.map(idx => (
                                        <Accordion show={idx.show} key={idx.id} title={idx.title} className='flat-toggle h6'>
                                       {idx.content}
                                        </Accordion>
                                    ))
                                }
                            </div>
                        </div>
                   </div>
                </div>
            </section>
    );
}

export default Faqs2;